import React, { useState } from 'react';
import { db } from '../firebase/firebase';
import { collection, addDoc, doc, updateDoc, getDoc } from 'firebase/firestore';
import '../styles/TransactionForm.css'; // Import custom styles if necessary

export default function TransactionForm({ cardId, categories, refreshCategories }) {
    const [amount, setAmount] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [note, setNote] = useState("");
    const [date, setDate] = useState("");

    const addTransaction = async () => {
        if (!amount || !selectedCategory) {
            alert("Please provide both amount and category.");
            return;
        }

        const transactionDate = date ? new Date(date) : new Date();

        try {
            await addDoc(collection(db, "cards", cardId, "transactions"), {
                amount: parseFloat(amount),
                category: selectedCategory,
                note,
                timestamp: transactionDate,
            });

            // Update the spent amount for the selected category
            const cardRef = doc(db, "cards", cardId);
            const cardSnap = await getDoc(cardRef);
            if (cardSnap.exists()) {
                const cardData = cardSnap.data();
                const updatedCategories = cardData.categories.map((cat) => {
                    if (cat.name === selectedCategory) {
                        const newSpent = (cat.spent || 0) + parseFloat(amount);
                        return { ...cat, spent: newSpent };
                    }
                    return cat;
                });
                await updateDoc(cardRef, { categories: updatedCategories });
                if (refreshCategories) refreshCategories(updatedCategories);
            }

            setAmount("");
            setSelectedCategory("");
            setNote("");
            setDate("");
        } catch (error) {
            console.error("Error adding transaction:", error);
            alert("Failed to add transaction. Please try again.");
        }
    };

    return (
        <div className="container mt-3">
            <h2 className="text-white mb-3">Add Transaction</h2>
            <form>
                <div className="mb-3">
                    <label htmlFor="amount" className="form-label">Amount</label>
                    <input type="number" className="form-control" id="amount" placeholder="Enter amount" value={amount} onChange={(e) => setAmount(e.target.value)} />
                </div>
                <div className="mb-3">
                    <label htmlFor="category" className="form-label">Category</label>
                    <select className="form-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                        <option value="">Select Category</option>
                        {categories.map((cat, index) => (
                            <option key={index} value={cat.name}>
                                {cat.name} (Spent: Rs {cat.spent || 0} / Limit: Rs {cat.limit})
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="note" className="form-label">Note</label>
                    <input type="text" className="form-control" id="note" placeholder="Enter note" value={note} onChange={(e) => setNote(e.target.value)} />
                </div>
                <div className="mb-3">
                    <label htmlFor="date" className="form-label">Date</label>
                    <input type="datetime-local" className="form-control" id="date" value={date} onChange={(e) => setDate(e.target.value)} />
                </div>
                <button type="button" onClick={addTransaction} className="btn btn-primary">Add Transaction</button>
            </form>
        </div>
    );
}
